import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MySubscriptionTab from './tabs/MySubscriptionTab';

const MySubscription = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
    }, [hash]);

    return (
        <div className="w-full max-w-[1550px] mx-auto bg-white shadow-[0_0_134px_14px_rgba(120,179,243,0.07)] rounded-2xl overflow-hidden p-6 pb-16 mb-16 origin-top" style={{ transform: 'scale(0.9)' }}>
            <MySubscriptionTab />
        </div>
    );
};

export default MySubscription;
